import React from 'react';
import { Box, Button, Image, Input, Link, Section, Strong, Text, Theme } from "@quarkly/widgets";
import { Override, SocialMedia } from "@quarkly/components";
import CollapsibleDialog from '../components/CollapsibleDialog.js'; // Import the dialog component

import article1 from '../resources/Articles/11-13 Editorial.pdf';
import article2 from '../resources/Articles/14-21 Kiran et al.pdf';
import article3 from '../resources/Articles/22-26 Vaishnav et al.pdf';
import article4 from '../resources/Articles/27-30 Agrawal et al.pdf';
import article5 from '../resources/Articles/31-41 Rajaram et al.pdf';
import article6 from '../resources/Articles/42-45 Sigh et al.pdf';
import article7 from '../resources/Articles/NJSOMA 2024 1(2) 57 to 59.pdf';
import article8 from '../resources/Articles/NJSOMA 2024 1(2) 60 to 65.pdf';
import article9 from '../resources/Articles/NJSOMA 2024 1(2) 66 to 69.pdf';
import article10 from '../resources/Articles/NJSOMA 2024 1(2) 70 to 73.pdf';
import article11 from '../resources/Articles/NJSOMA 2024 1(2) 74 to 76.pdf';
import contentArray from './resoucePages/AbstractContents.js';

const ArticleBlock = ({ title, authors, abstractIndex, pdfLink, handleOpenPopup, isEditorial }) => (
  <>
    <Text margin="0px 0px 20px 0px" font={isEditorial ? "normal 600 25px/1.2 --fontFamily-sans" : "normal 400 20px/1.2 --fontFamily-sans"} color={isEditorial ? undefined : "#505257"} maxWidth="90%">
      {title}
    </Text>
    {authors && (
      <Text margin="0px 0px 60px 40px" font="normal 200 20px/1.2 --fontFamily-sans" color="#505257" maxWidth="90%">
        {authors}<br />
        <a href="#" onClick={() => handleOpenPopup(abstractIndex)}>Abstract</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a href={pdfLink} target="_blank" rel="noopener noreferrer">PDF</a>
      </Text>
    )}
  </>
);

const JournalSection = ({ contentArray, popupOpen, handleOpenPopup, handleClosePopup, selectedContent }) => (
  <Section padding="80px 0 80px 0" maxHeight="500px" overflowY="auto">
    <Override slot="SectionContent" padding="0px 0 0px 0px" />

     {/* Header */}
     <Text margin="0px 0px 80px 0px" font="normal 600 42px/1.2 --fontFamily-sans" maxWidth="90%">
       NJSOMA Volume 1| Issue 1| Jan 2024<br />
       <hr />
     </Text>

     {/* Editorial */}
     <ArticleBlock 
       title="Fetal Autopsy: Insight and Utility" 
       authors="Sontakke YA, Chaudhari VA, Gowda M" 
       abstractIndex={contentArray[0]}
       pdfLink={article1} 
       isEditorial={true} 
     />

     {/* Original Articles */}
     <Text margin="0px 0px 20px 0px" font="normal 600 25px/1.2 --fontFamily-sans" maxWidth="90%">
       ORIGINAL ARTICLES
     </Text>
     <ArticleBlock 
      title="C677T Genetic Polymorphisms in Clinicodevelopmental Spectrum of Neural Tube Defects" 
      authors="Kiran K, Gladwin VR, Bhat BV, Kubera NS" 
      abstractIndex={contentArray[1]} 
      pdfLink={article2} 
    />
    <ArticleBlock 
      title="Morphologic and Morphometric Study of Intercondylar Notch of Femur in Relation to ACL Injuries" 
      authors="Vaishnav SP, Sharma D, Baweja S, Sharma V" 
      abstractIndex={contentArray[2]} 
      pdfLink={article3} 
    />
    <ArticleBlock 
      title="A Study of Anthropometric Assessment of SC and ST Boys of Chhattisgarh" 
      authors="Agrawal P, Chatterjee M, Agrawal PC" 
      abstractIndex={contentArray[3]} 
      pdfLink={article4} 
    />

    {/* Review Articles */}
    <Text margin="0px 0px 20px 0px" font="normal 600 25px/1.2 --fontFamily-sans" maxWidth="90%">
      REVIEW ARTICLES
    </Text>
    <ArticleBlock 
      title="A Comprehensive Synthesis of Anatomy and Histology of the Triangular Fibrocartilage Complex" 
      authors="Rajaram N, Kumar VD" 
      abstractIndex={contentArray[4]}
      pdfLink={article5} 
    />
    <ArticleBlock 
      title="From Dissection Tables to Digital Screens: YouTube in Human Anatomy Learning" 
      authors="Singh G, Mishra DN" 
      abstractIndex={contentArray[5]}
      pdfLink={article6} 
    />

    {/* Header */}
    <Text margin="0px 0px 80px 0px" font="normal 600 42px/1.2 --fontFamily-sans" maxWidth="90%">
      NJSOMA Volume 1| Issue 2| July 2024<br />
      <hr />
    </Text>

    {/* Editorial */}
    <ArticleBlock 
      title="Time for Self-upliftment - AI Tools as a Teaching-Learning Resource" 
      authors="Sontakke YA, Dinesh Kumar V" 
      abstractIndex={contentArray[6]} 
      pdfLink={article7} 
      isEditorial={true} 
    />

    {/* Original Articles */}
    <Text margin="0px 0px 20px 0px" font="normal 600 25px/1.2 --fontFamily-sans" maxWidth="90%">
      ORIGINAL ARTICLES
    </Text>
    <ArticleBlock 
      title="Comparative Study of Pancreatic Head and Body Size between Diabetic and Non Diabetic Individual 35-65 Years by Ultrasonography" 
      authors="Sisodiya H, Barjatya R, Solanki BS, Mathur R" 
      abstractIndex={contentArray[7]} 
      pdfLink={article8} 
    />
    <ArticleBlock 
      title="Morphology and Morphometry of Glenoid Fossa of the Adult Human Scapula and its Clinical Application" 
      authors="Narayana PSV, Devi KVNG, Kavitha T, Mayuri MVR" 
      abstractIndex={contentArray[8]} 
      pdfLink={article9} 
    />
    <ArticleBlock 
      title="Self-Directed Learning as a Method for Teaching Gross Anatomy of Kidney among MBBS Students in a Medical College of Kolkata: An Interventional Comparative Study" 
      authors="Biswas S, Srimani P, Nandy S" 
      abstractIndex={contentArray[9]} 
      pdfLink={article10} 
    />

    {/* Case Report */}
    <Text margin="0px 0px 20px 0px" font="normal 600 25px/1.2 --fontFamily-sans" maxWidth="90%">
      CASE REPORT
    </Text>
    <ArticleBlock 
      title="Trifurcation of Left Coronary Artery with Absent Left Circumflex Artery and Superdominant Right Coronary Artery in the Heart" 
      authors="Nikilesh S, Ambiga R, Stephen PC, Verma S, Suma HY" 
      abstractIndex={contentArray[10]}
      pdfLink={article11} 
    />

    {/* Collapsible Dialog for Popups */}
    <CollapsibleDialog open={popupOpen} onClose={handleClosePopup} content={selectedContent} />
  </Section>
);

export default JournalSection;


// import React, { useState } from "react";
// import { Box, Button, Image, Input, Link, Section, Strong, Text, Theme } from "@quarkly/widgets";

// import CollapsibleDialog from '../components/CollapsibleDialog.js';

// import article1 from '../resources/Articles/11-13 Editorial.pdf';
// import article2 from '../resources/Articles/14-21 Kiran et al.pdf';
// import article3 from '../resources/Articles/22-26 Vaishnav et al.pdf';
// import article4 from '../resources/Articles/27-30 Agrawal et al.pdf';
// import article5 from '../resources/Articles/31-41 Rajaram et al.pdf';
// import article6 from '../resources/Articles/42-45 Sigh et al.pdf';
// import article7 from '../resources/Articles/NJSOMA 2024 1(2) 57 to 59.pdf';
// import article8 from '../resources/Articles/NJSOMA 2024 1(2) 60 to 65.pdf';
// import article9 from '../resources/Articles/NJSOMA 2024 1(2) 66 to 69.pdf';
// import article10 from '../resources/Articles/NJSOMA 2024 1(2) 70 to 73.pdf';
// import article11 from '../resources/Articles/NJSOMA 2024 1(2) 74 to 76.pdf';


// const ArticleBlock = ({ title, authors, abstractIndex, pdfLink, isEditorial }) => (
//   <>
//     <Text margin="0px 0px 20px 0px" font={isEditorial ? "normal 600 25px/1.2 --fontFamily-sans" : "normal 400 20px/1.2 --fontFamily-sans"} color={isEditorial ? undefined : "#505257"} maxWidth="90%">
//       {title}
//     </Text>
//     {authors && (
//       <Text margin="0px 0px 60px 40px" font="normal 200 20px/1.2 --fontFamily-sans" color="#505257" maxWidth="90%">
//         {authors}<br />
//         <a href="#" onClick={() => handleOpenPopup(contentArray[abstractIndex])}>Abstract</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
//         <a href={pdfLink} target="_blank" rel="noopener noreferrer">PDF</a>
//       </Text>
//     )}
//   </>
// );

// const JournalSection1 = () => (

//   <Section padding="80px 0 80px 0" maxHeight="500px" overflowY="auto">
//     <Override slot="SectionContent" padding="0px 0 0px 0px" />

//     {/* Header */}
//     <Text margin="0px 0px 80px 0px" font="normal 600 42px/1.2 --fontFamily-sans" maxWidth="90%">
//       NJSOMA Volume 1| Issue 1| Jan 2024<br />
//       <hr />
//     </Text>

//     {/* Editorial */}
//     <ArticleBlock 
//       title="Fetal Autopsy: Insight and Utility" 
//       authors="Sontakke YA, Chaudhari VA, Gowda M" 
//       abstractIndex={0} 
//       pdfLink={article1} 
//       isEditorial={true} 
//     />

//     {/* Original Articles */}
//     <Text margin="0px 0px 20px 0px" font="normal 600 25px/1.2 --fontFamily-sans" maxWidth="90%">
//       ORIGINAL ARTICLES
//     </Text>
//     <ArticleBlock 
//       title="C677T Genetic Polymorphisms in Clinicodevelopmental Spectrum of Neural Tube Defects" 
//       authors="Kiran K, Gladwin VR, Bhat BV, Kubera NS" 
//       abstractIndex={1} 
//       pdfLink={article2} 
//     />
//     <ArticleBlock 
//       title="Morphologic and Morphometric Study of Intercondylar Notch of Femur in Relation to ACL Injuries" 
//       authors="Vaishnav SP, Sharma D, Baweja S, Sharma V" 
//       abstractIndex={2} 
//       pdfLink={article3} 
//     />
//     <ArticleBlock 
//       title="A Study of Anthropometric Assessment of SC and ST Boys of Chhattisgarh" 
//       authors="Agrawal P, Chatterjee M, Agrawal PC" 
//       abstractIndex={3} 
//       pdfLink={article4} 
//     />

//     {/* Review Articles */}
//     <Text margin="0px 0px 20px 0px" font="normal 600 25px/1.2 --fontFamily-sans" maxWidth="90%">
//       REVIEW ARTICLES
//     </Text>
//     <ArticleBlock 
//       title="A Comprehensive Synthesis of Anatomy and Histology of the Triangular Fibrocartilage Complex" 
//       authors="Rajaram N, Kumar VD" 
//       abstractIndex={4} 
//       pdfLink={article5} 
//     />
//     <ArticleBlock 
//       title="From Dissection Tables to Digital Screens: YouTube in Human Anatomy Learning" 
//       authors="Singh G, Mishra DN" 
//       abstractIndex={5} 
//       pdfLink={article6} 
//     />

//     {/* Header */}
//     <Text margin="0px 0px 80px 0px" font="normal 600 42px/1.2 --fontFamily-sans" maxWidth="90%">
//       NJSOMA Volume 1| Issue 2| July 2024<br />
//       <hr />
//     </Text>

//     {/* Editorial */}
//     <ArticleBlock 
//       title="Time for Self-upliftment - AI Tools as a Teaching-Learning Resource" 
//       authors="Sontakke YA, Dinesh Kumar V" 
//       abstractIndex={6} 
//       pdfLink={article7} 
//       isEditorial={true} 
//     />

//     {/* Original Articles */}
//     <Text margin="0px 0px 20px 0px" font="normal 600 25px/1.2 --fontFamily-sans" maxWidth="90%">
//       ORIGINAL ARTICLES
//     </Text>
//     <ArticleBlock 
//       title="Comparative Study of Pancreatic Head and Body Size between Diabetic and Non Diabetic Individual 35-65 Years by Ultrasonography" 
//       authors="Sisodiya H, Barjatya R, Solanki BS, Mathur R" 
//       abstractIndex={7} 
//       pdfLink={article8} 
//     />
//     <ArticleBlock 
//       title="Morphology and Morphometry of Glenoid Fossa of the Adult Human Scapula and its Clinical Application" 
//       authors="Narayana PSV, Devi KVNG, Kavitha T, Mayuri MVR" 
//       abstractIndex={8} 
//       pdfLink={article9} 
//     />
//     <ArticleBlock 
//       title="Self-Directed Learning as a Method for Teaching Gross Anatomy of Kidney among MBBS Students in a Medical College of Kolkata: An Interventional Comparative Study" 
//       authors="Biswas S, Srimani P, Nandy S" 
//       abstractIndex={9} 
//       pdfLink={article10} 
//     />

//     {/* Case Report */}
//     <Text margin="0px 0px 20px 0px" font="normal 600 25px/1.2 --fontFamily-sans" maxWidth="90%">
//       CASE REPORT
//     </Text>
//     <ArticleBlock 
//       title="Trifurcation of Left Coronary Artery with Absent Left Circumflex Artery and Superdominant Right Coronary Artery in the Heart" 
//       authors="Nikilesh S, Ambiga R, Stephen PC, Verma S, Suma HY" 
//       abstractIndex={10} 
//       pdfLink={article11} 
//     />

//     {/* Footer */}
//     <CollapsibleDialog open={popupOpen} onClose={handleClosePopup} content={selectedContent} />
//   </Section>
// );

// export default JournalSection;